module.exports = __webpack_public_path__ + "static/img/bar.192ac579.svg";